import boxen from "boxen";

import { ELKLogger } from "./Commons/Logging/ELKLogger";

const versionArray = process.version
    .replace(/[^0-9.]/g, "")
    .split(".")
    .map(x => parseInt(x, 10));

const nodejsVersion = {
    major: versionArray[0] || 0,
    minor: versionArray[1] || 0,
    patch: versionArray[2] || 0,
};

export const checkNodeJsVersion = nodejsVersion.major >= 22;

if (!checkNodeJsVersion) {
    const message = `Your version of NodeJS ${process.version} is outdated, expected version 22.x.x or greater
Please update the NodeJS from http://nodejs.org`;

    ELKLogger.error(message, { stackTrace: new Error().stack });
    // eslint-disable-next-line no-console
    console.log(boxen(message, { borderStyle: "double", borderColor: "green", padding: 2, margin: 3 }));
}
